import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { ProcedureThreeService } from '../../services/procedures/procedure-three.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {environment} from '../../../environments/environment';
import {FilesService} from "../../services/files.service";

@Component({
  selector: 'ngx-procedure-three',
  templateUrl: './procedure-three.component.html',
  styleUrls: ['./procedure-three.component.scss'],
})
export class ProcedureThreeComponent implements OnInit {

  requirementsEnvironmentalAspects: any = [];

  legalRequirements: any = {};
  legalRequirementsCopy: any = {};
  loadingAspects = false;
  loading = false;

  responsableOptions = [
    {
      name: 'Responsable de la estación de servicio',
      value: 1,
    },
    {
      name: 'Área de mantenimiento',
      value: 2,
    },
    {
      name: 'Responsable Técnico',
      value: 3,
    },
    {
      name: 'Responsable Personal de Mantenimiento',
      value: 4,
    },
    {
      name: 'Encargado de la estación de servicio',
      value: 5,
    },
  ];

  documents = {
    legal: '',
  };
  downloading = false;

  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  signaturePadOptions: Object;
  @Input() stationId;
  state = 'Actividades';
  constructor(
    private procedureThreeService: ProcedureThreeService,
    private fileService: FilesService,
  ) { }

  async ngOnInit() {
    this.getRequirementsEnvironmentalAspects();
    this.getDocuments();
    await this.getLegalRequirements();
    await this.getLegalRequirementsStation();
    await this.formatDataTemp();
    const width = document.documentElement.clientWidth * .36;
    this.signaturePadOptions = {
      maxWidth: 1,
      'minWidth': 0.8,
      'backgroundColor': 'RGBA(245, 247, 249, 1.00)',
      'canvasWidth': width,
    };
  }

  loadImage(evt, key, index) {
    if (!evt.target.files.length) return;
    this.legalRequirements[key].evidenceCompliance[index].file = evt.target.files[0];
    this.legalRequirements[key].evidenceCompliance[index].compliment = true;
  }

  onChangeTab(event) {
    this.state = event.tabTitle;
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  async getRequirementsEnvironmentalAspects () {
    this.loadingAspects = true;
    const [err, result] = await this.procedureThreeService.getRequirementsEnvironmentalAspects(this.stationId) as any;
    this.loadingAspects = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error');
    this.requirementsEnvironmentalAspects = result.data;
  }

  async getLegalRequirements() {
    this.loading = true;
    const [err, {data: result}] = await this.procedureThreeService.getLegalRequirements(this.stationId) as any;
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error');
    this.legalRequirements = result;
  }

  async getLegalRequirementsStation () {
    this.loading = true;
    const [err, {data: result}] = await this.procedureThreeService.getLegalRequirementsStation(this.stationId) as any;
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error');
    for await (const requirement of Object.keys(result)) this.legalRequirements[requirement] = result[requirement];
  }

  async formatDataTemp () {
    for await (const requirement of Object.keys(this.legalRequirements)) {
      for await (const compliance of this.legalRequirements[requirement].evidenceCompliance) {
        compliance.edit = compliance.hasOwnProperty('edit') ? compliance.edit : true;
      }
    }
    this.legalRequirementsCopy = this.legalRequirements;
  }

  async save(key: any, index: number) {
    this.loading = true;
    const data = new FormData();
    if (this.legalRequirements[key].evidenceCompliance[index].file) {
      this.legalRequirements[key].evidenceCompliance[index].file.customName = `${key}_0`;
      data.append('file', this.legalRequirements[key].evidenceCompliance[index].file);
      delete this.legalRequirements[key].evidenceCompliance[index].file;
    }
    this.legalRequirements[key].evidenceCompliance[index].edit = false;
    this.legalRequirementsCopy[key].evidenceCompliance[index] = this.legalRequirements[key].evidenceCompliance[index];
    data.append('data', JSON.stringify(this.legalRequirementsCopy[key]));
    const [err] = await this.procedureThreeService.store(this.stationId, key, data);
    this.loading = false;
    if (err) {
      this.legalRequirements[key].evidenceCompliance[index].edit = true;
      return this.alert('Oops, intenta más tarde', 'error');
    }
    this.alert('Guardado con éxito');
  }

  async getDocuments() {
    this.documents.legal = `${environment.baseEndpoint}/filesGeneratorv2/implementation/three/legal/requirements/${this.stationId}`;
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async downloadFile(url, name) {
    this.downloading = true;
    await this.fileService.downloadFile(url, name.toLowerCase().replace(' ', '_'));
    this.downloading = false;
  }
}
